// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { Auth0Provider } from '@auth0/auth0-react';
import './styles/App.css';
import App from './App';
import { AUTH0_AUDIENCE } from './routes';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{ redirect_uri: `${window.location.origin}/auth/callback`, audience: AUTH0_AUDIENCE }} 
      >
      <CookiesProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CookiesProvider>
    </Auth0Provider>
  </React.StrictMode>
);